import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kg.reviews');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-kg-reviews',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.kg.reviews/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #252925;
}

* {
  box-sizing: border-box;
}

.kg-coming-soon {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: #f7f8f4;
}

.kg-coming-soon__header {
  display: flex;
  min-height: 102px;
  flex: 0 0 102px;
  align-items: center;
  padding: 18px 34px;
  border-bottom: 1px solid #dfe4db;
  background: #fff;
}

.kg-coming-soon__header h1 {
  margin: 0;
}

.kg-coming-soon__header p {
  margin: 8px 0 0;
  color: #737a73;
  font-size: 12px;
  font-weight: 600;
}

.kg-coming-soon__main {
  place-items: center;
}

.kg-coming-soon__panel {
  display: grid;
  width: min(100%, 560px);
  min-height: 0;
  place-items: center;
  align-content: center;
  padding: 54px 42px;
  border: 1px solid #dfe4db;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(43, 54, 42, 0.055);
  text-align: center;
}

.kg-coming-soon__icon {
  display: grid;
  width: 64px;
  height: 64px;
  place-items: center;
  border-radius: 18px;
  color: #667a5d;
  background: #edf2e9;
  font-size: 24px;
}

.kg-coming-soon__eyebrow {
  margin: 22px 0 0;
  color: #d85a36;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.kg-coming-soon__panel h2 {
  margin: 10px 0 0;
  color: #252925;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1.25;
}

.kg-coming-soon__description {
  margin: 13px 0 0;
  color: #747c74;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
}

@media (max-width: 700px) {
  .kg-coming-soon__header {
    min-height: 88px;
    flex-basis: 88px;
    padding-inline: 20px;
  }
  .kg-coming-soon__panel {
    min-height: 0;
    padding: 42px 24px;
  }
  .kg-coming-soon__panel h2 {
    font-size: 26px;
  }
}`],
})
export class PageKgReviewsComponent implements OnInit {
    public filter: string = '전체';
    public keyword: string = '';
    public sortMode: string = '마감 임박 순';
    public viewMode: 'list' | 'detail' = 'list';
    public selectedTaskId: string = '';
    public filters: string[] = ['전체', '대기', '검수 중', '제출 완료'];
    public tasks: any[] = [];
    public loadError: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadWorkspaceTasks();
        this.restoreRouteState();
        await this.service.render();
    }

    private async loadWorkspaceTasks() {
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '검수 작업을 불러오지 못했습니다.'));
            const state = this.unwrapState(payload);
            if (!state || !Array.isArray(state.tasks)) throw new Error('검수 작업 응답 형식이 올바르지 않습니다.');
            const projects = Array.isArray(state.projects) ? state.projects : [];
            const evaluations = state.evaluations && typeof state.evaluations === 'object' ? state.evaluations : {};
            this.tasks = state.tasks
                .filter((task: any) => String(task && task.kind || '').toLowerCase() === 'kg')
                .map((task: any) => this.normalizeTask(task, projects, evaluations[String(task.id || '')]));
            this.loadError = '';
            return true;
        } catch (error) {
            this.tasks = [];
            this.loadError = error instanceof Error ? error.message : 'KG 검수 작업을 불러오지 못했습니다.';
            return false;
        }
    }

    public async reloadWorkspaceTasks() {
        await this.loadWorkspaceTasks();
        this.viewMode = 'list';
        await this.service.render();
    }

    private normalizeTask(task: any, projects: any[], evaluation: any) {
        const projectId = String(task.projectId || task.project_id || '');
        const project = projects.find((item: any) => String(item && (item.id || item.projectId || item.project_id) || '') === projectId) || {};
        const samples = Array.isArray(task.samples) ? task.samples : [];
        const total = Number(task.total ?? task.sampleCount ?? task.sample_count ?? samples.length) || 0;
        const submitted = !!(evaluation && (evaluation.submitted === true || evaluation.submitted_at || evaluation.submittedAt || evaluation.recorded_at || evaluation.task_id));
        const completed = submitted ? total : (Number(task.completed ?? task.completedCount ?? task.completed_count) || 0);
        const survey = String(task.survey || task.surveyName || task.survey_name || '검수 설문지');
        const surveyVersion = String(task.surveyVersion || task.survey_version || '');
        return Object.assign({}, task, {
            id: String(task.id || ''),
            projectId: projectId,
            projectName: this.projectName(task, project, projectId),
            round: Number(task.round) || this.roundFromId(task.id),
            dataset: String(task.title || task.dataset || 'KG 검수 작업'),
            created: this.dateTimeLabel(task.created || task.createdAt || task.created_at),
            status: submitted ? '제출 완료' : this.statusLabel(task.status),
            qaCount: Number(task.qaCount ?? task.qa_count) || 0,
            kgCount: Number(task.kgCount ?? task.kg_count ?? total) || total,
            sampleCount: total,
            completedCount: completed,
            survey: this.versionedLabel(survey, surveyVersion),
            reviewer: String(task.reviewer || task.assignee || task.assigneeName || task.assignee_name || '검수 담당자'),
            assigneeId: String(task.assigneeId || task.assignee_id || ''),
            assigneeEmail: String(task.assigneeEmail || task.assignee_email || ''),
            due: this.dateLabel(task.due || task.dueAt || task.due_at)
        });
    }

    private projectName(task: any, project: any, projectId: string) {
        if (typeof task.project === 'string' && task.project.trim()) return task.project;
        return String(task.projectName || task.project_name || project.name || project.title || projectId || '검수 프로젝트');
    }

    private roundFromId(id: any) {
        const match = String(id || '').match(/-R(\d+)$/i);
        return match ? Number(match[1]) : 1;
    }

    private statusLabel(status: any) {
        const value = String(status || '').trim();
        const key = value.toLowerCase().replace(/[\s_-]+/g, '');
        if (value === '제출 완료' || value === '검수 완료' || ['submitted', 'completed', 'complete', 'done', 'approved'].includes(key)) return '제출 완료';
        if (value === '검수 중' || ['inprogress', 'progress', 'reviewing', 'started'].includes(key)) return '검수 중';
        return value === '대기' ? value : '대기';
    }

    private versionedLabel(name: string, version: string) {
        if (!version || name.toLowerCase().endsWith(version.toLowerCase())) return name;
        return name + ' ' + version;
    }

    private dateLabel(value: any) {
        if (!value) return '—';
        const text = String(value);
        const match = text.match(/^(\d{4})[-.](\d{2})[-.](\d{2})/);
        return match ? [match[1], match[2], match[3]].join('.') : text;
    }

    private dateTimeLabel(value: any) {
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return this.dateLabel(date.toISOString()) + ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
    }

    private async readResponse(response: Response) {
        try {
            return await response.json();
        } catch (error) {
            return {};
        }
    }

    private unwrapState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private responseMessage(payload: any, fallback: string) {
        return String(payload && (payload.message || payload.error && (payload.error.message || payload.error)) || fallback);
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }

    public visibleTasks() {
        if (this.isAdmin()) return this.tasks;
        const session = this.service.auth.session || {};
        const email = String(session.email || '').trim().toLowerCase();
        const id = String(session.id || '').trim();
        return this.tasks.filter((task: any) => {
            const hasAssignment = !!String(task.assigneeEmail || '').trim() || !!String(task.assigneeId || '').trim();
            return !hasAssignment
                || (!!email && email === String(task.assigneeEmail || '').toLowerCase())
                || (!!id && id === String(task.assigneeId || ''));
        });
    }

    public filteredTasks() {
        const query = this.keyword.trim().toLowerCase();
        const tasks = this.visibleTasks().filter((task: any) => {
            const statusMatch = this.filter === '전체' || task.status === this.filter;
            const queryMatch = !query
                || String(task.dataset || '').toLowerCase().includes(query)
                || String(task.projectName || '').toLowerCase().includes(query)
                || String(task.projectId || '').toLowerCase().includes(query)
                || String(task.survey || '').toLowerCase().includes(query)
                || String(task.reviewer || '').toLowerCase().includes(query);
            return statusMatch && queryMatch;
        });

        return tasks.slice().sort((a: any, b: any) => {
            if (this.sortMode === '진행률 높은 순') return this.taskProgress(b) - this.taskProgress(a);
            if (this.sortMode === '그래프 많은 순') return Number(b.kgCount || 0) - Number(a.kgCount || 0);
            if (this.sortMode === '최근 생성 순') return String(b.created || '').localeCompare(String(a.created || ''));
            return this.dueTimestamp(a) - this.dueTimestamp(b);
        });
    }

    public filterCount(filter: string) {
        const tasks = this.visibleTasks();
        return filter === '전체'
            ? tasks.length
            : tasks.filter((task: any) => task.status === filter).length;
    }

    public taskRoute(task: any) {
        return '/review-tasks/kg/' + task.id;
    }

    public taskActionRoute(task: any) {
        return task && task.status === '제출 완료'
            ? '/review-results/kg/' + task.id
            : this.taskRoute(task);
    }

    public surveyRoute(task: any) {
        return '/review-surveys/kg/' + task.id;
    }

    public async setFilter(filter: string) {
        this.filter = filter;
        await this.service.render();
    }

    private restoreRouteState() {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search || '');
        const taskId = params.get('task') || '';
        if (params.get('view') === 'detail' && this.visibleTasks().some((task: any) => task.id === taskId)) {
            this.selectedTaskId = taskId;
            this.viewMode = 'detail';
        }
    }

    public selectedTask() {
        const tasks = this.visibleTasks();
        return tasks.find((task: any) => task.id === this.selectedTaskId) || tasks[0] || {};
    }

    public async showTaskDetail(task: any) {
        this.selectedTaskId = task && task.id || '';
        this.viewMode = 'detail';
        await this.service.render();
    }

    public async selectTask(task: any) {
        this.selectedTaskId = task && task.id || '';
        await this.service.render();
    }

    public async showTaskList() {
        this.viewMode = 'list';
        await this.service.render();
    }

    public taskActionLabel(task: any) {
        if (!task) return '검수 시작';
        if (task.status === '제출 완료') return '결과 보기';
        if (task.status === '검수 중') return '검수 계속';
        return '검수 시작';
    }

    public taskProgress(task: any) {
        const total = Number(task && task.sampleCount) || 0;
        return total ? (Number(task.completedCount) || 0) / total * 100 : 0;
    }

    public totalKgCount() {
        return this.visibleTasks().reduce((sum: number, task: any) => sum + Number(task.kgCount || 0), 0);
    }

    public totalSampleCount() {
        return this.visibleTasks().reduce((sum: number, task: any) => sum + Number(task.sampleCount || 0), 0);
    }

    public totalCompletedCount() {
        return this.visibleTasks().reduce((sum: number, task: any) => sum + Number(task.completedCount || 0), 0);
    }

    public remainingSampleCount() {
        return Math.max(0, this.totalSampleCount() - this.totalCompletedCount());
    }

    public overallCompletionRate() {
        const total = this.totalSampleCount();
        return total ? Math.round(this.totalCompletedCount() / total * 100) : 0;
    }

    public nextActionTask() {
        return this.visibleTasks()
            .filter((task: any) => task.status !== '제출 완료')
            .slice()
            .sort((a: any, b: any) => this.dueTimestamp(a) - this.dueTimestamp(b))[0] || null;
    }

    private dueTimestamp(task: any) {
        const parts = String(task && task.due || '').split('.').map((value: string) => Number(value));
        if (parts.length < 3 || parts.some((value: number) => !Number.isFinite(value))) return Number.MAX_SAFE_INTEGER;
        return Date.UTC(parts[0], parts[1] - 1, parts[2]);
    }

    public daysUntilDue(task: any) {
        const due = this.dueTimestamp(task);
        if (!Number.isFinite(due) || due === Number.MAX_SAFE_INTEGER) return 999;
        const now = new Date();
        const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        return Math.ceil((due - today) / 86400000);
    }

    public dueCountdownLabel(task: any) {
        if (task && task.status === '제출 완료') return '제출 완료';
        const days = this.daysUntilDue(task);
        if (days < 0) return '기한 초과';
        if (days === 0) return '오늘 마감';
        return 'D-' + days;
    }

    public dueUrgencyClass(task: any) {
        if (task && task.status === '제출 완료') return 'is-complete';
        const days = this.daysUntilDue(task);
        if (days <= 2) return 'is-urgent';
        if (days <= 5) return 'is-near';
        return 'is-safe';
    }

    public async resetListFilters() {
        this.filter = '전체';
        this.keyword = '';
        this.sortMode = '마감 임박 순';
        await this.service.render();
    }

    public statusClass(status: string) {
        if (status === '제출 완료') return 'is-complete';
        if (status === '검수 중') return 'is-progress';
        return 'is-waiting';
    }
}

export default PageKgReviewsComponent;